import { render } from "./DeleteUser.vue?vue&type=template&id=78ff5c54&scoped=true&ts=true"
import script from "./DeleteUser.vue?vue&type=script&lang=ts"
export * from "./DeleteUser.vue?vue&type=script&lang=ts"

import "./DeleteUser.vue?vue&type=style&index=0&id=78ff5c54&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ff5c54"]])

export default __exports__